import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mark-type',
  templateUrl: './mark-type.component.html',
  styleUrls: ['./mark-type.component.css']
})
export class MarkTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
